import { Badge } from "@cleanbudget/ui/components/badge";
import { cn } from "@cleanbudget/ui/lib/utils";
import type { ReactNode } from "react";
import { match } from "ts-pattern";

/**
 * A status, the same way on every screen: a coloured dot and the status's name. Each area maps its
 * own statuses to a tone (an order's `paid` is `positive`, `expired` is `negative`).
 */
export type StatusTone = "positive" | "neutral" | "attention" | "negative";

export function StatusBadge({ tone, children }: { tone: StatusTone; children: ReactNode }) {
	const dot = match(tone)
		.with("positive", () => "bg-emerald-500")
		.with("neutral", () => "bg-muted-foreground")
		.with("attention", () => "bg-amber-500")
		.with("negative", () => "bg-destructive")
		.exhaustive();
	return (
		<Badge variant="outline" className="gap-1.5">
			<span className={cn("size-1.5 rounded-full", dot)} aria-hidden />
			{children}
		</Badge>
	);
}
